export const BUDGET_MANAGER_TAG_GROUP_SLUG_PREFIX = 'budget-manager-automation';
